class UpdateCOTranscriptsModel {
  constructor(vfId, jobId, accountId, eventType, eventDescription, createdBy) {
    this.vfId = vfId;
    this.jobId = jobId;
    this.accountId = accountId;
    this.eventType = eventType;
    this.eventDescription = eventDescription;
    this.createdBy = createdBy;
  }
}
export default UpdateCOTranscriptsModel;
